import {getEnv} from '../../common/env/env';
import {NearItemVo} from '../../common/shared/api/gateway/viewer/NearItemVo.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {NearItem} from '../generated/types';
import {createAgeGrade} from './AgeGrade';
import {createSlideType} from './SlideType.enum';

export function createNearItem({
  product_id,
  slide_type,
  age_grade,
  title,
  thumbnail,
  is_free,
}: NearItemVo): NearItem {
  return {
    productId: product_id,
    slideType: createSlideType(slide_type),
    ageGrade: createAgeGrade(age_grade),
    title,
    thumbnail: thumbnail
      ? thumbnail.startsWith('http')
        ? thumbnail
        : getKageUrl({
            kageUrlPrefix: getEnv().kageUrlPrefix,
            kageId: thumbnail,
            resolution: 'th3',
          })
      : undefined,
    isFree: is_free,
  };
}
